import { IVisitedOffersProviderProps, VisitedOffersProvider } from '@cian/frontend-visited-offers-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectActiveTab } from '../../selectors/activeTab';
import { selectUser } from '../../selectors';
import { ETabType } from '../../types/filters';
import { useApplicationContext } from '../../utils/applicationContext';
import { RecommendationsListContainer } from '../RecommendationsListContainer';

export const RecommendationsContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const { isAuthenticated } = useSelector(selectUser);
  const { activeTab } = useSelector(selectActiveTab);

  const isAdvertisementsTab = activeTab !== ETabType.JK && activeTab !== ETabType.SavedSearches;

  const { settings, enabled } = config.get<IVisitedOffersProviderProps>('audience.visitedOffers') || {};

  if (!isAuthenticated || !isAdvertisementsTab) {
    return null;
  }

  return (
    <VisitedOffersProvider settings={settings} enabled={enabled}>
      <RecommendationsListContainer />
    </VisitedOffersProvider>
  );
};
